import React from 'react';

import Data from './Data';

const HeadingSidebar = (props) => {
  return <Data {...props} />;
};

export default HeadingSidebar;
